<template>
  <div>
    <Radio v-bind="$attrs" v-model="initialValue">
      <template #icon="props">
        <v-icon
          :name="props.checked ? 'selected' : 'unselected'"
          :style="{
            '--size': size
          }"
        ></v-icon>
      </template>
      <slot></slot>
    </Radio>
  </div>
</template>

<script>
import { create } from '../../utils'
import { Radio } from '@vivo/shop-ui-h5'

// 对 shop-ui-h5 的 radio 进行封装 将 icon 统一内置
export default create({
  name: 'radio2',

  components: {
    Radio
  },

  props: {
    value: {
      type: [Boolean, String],
      default: ''
    },

    // 控制 icon 大小 默认是 45px
    size: {
      type: [String],
      default: '45px'
    }
  },

  data() {
    return {
      initialValue: false
    }
  },

  watch: {
    // 处理 v-model 属性
    value: {
      handler(newVal) {
        this.initialValue = newVal
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    change(val) {
      this.$emit('change', val)
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
